export const pageTitleTexts = {
    loginPage: "Giriş Sayfası",
    dashboard: "Tahsilat Uygulaması",
    paymentPageV1: "Ödeme Sayfası",
    customerList: "Müşteri Listesi",
    insertCustomer: "Yeni Müşteri",
    updateCustomer: "Müşteri Kartını Düzenle",
    insertCustomerWithExcel: "Excel ile Müşteri Aktar",
    createSheetPayment: "Toplu Ödeme Başlat",
    createFreePayment: "Serbest Ödeme Başlat",
    paymentLink: "Gönderilen Ödeme Linkleri",
    userList: "Kullanıcı Listesi",
    insertUser: "Yeni Kullanıcı Ekle",
    updateUser: "Kullanıcı Düzenle",
    userCustomerMatch: "Kullanıcı-Müşteri Eşleştir",
    orderReport: "Tahsilat Hareketleri",
    paymentSyncErp: "ERP Fiş Aktarımı",
    cronJobSettings: "Zamanlanmış Görev Tanımları",
    cronJobRecords: "Zamanlanmış Görev Tanımları",
    posConnetcionSettings: "Pos Entegrasyonları",
    parameters: "Ayarlar",
    userProfile: "Profilim",
    orderDetail: "İşlem Detayı",
    unlimitedPaymentLink : "Süresiz Ödeme Linki Oluştur",
    createPassword: "Şifre Oluştur",
    paymentSetList: "Ödeme Kuralı Listesi",
    createPaymentSet: "Ödeme Kuralı Oluştur",
    updatePaymentSet: "Ödeme Kuralı Güncelle",
    orderInstallmentsReport: "Geri Ödeme Raporları",
}